<template>
  <div id="appcontactsupport">
    <div class="pa-2">
      <v-row justify="space-between">
        <v-col cols="12" md="12">
          <ContactFormSupport />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import ContactFormSupport from "@/components/app-components/global/ContactFormSupport.vue";

export default {
  name: "AppPlannerView",
  components: { ContactFormSupport },
  data: () => ({}),
};
</script>
